import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router';

import appSelectors from '@/redux/app/appSelectors';
import contactsSelectors from '@/redux/contacts/contactsSelectors';

import contactsOperations from '@/redux/contacts/contactsOperations';

import useMatchMedia from '@/hooks/useMatchMedia';

import RouteNames from '@/router/routes';

import VkIcon from '@/images/footer/vk.svg?react';
import DzenIcon from '@/images/footer/dzen.svg?react';
import YoutubeIcon from '@/images/footer/youtube.svg?react';
import TgIcon from '@/images/footer/tg.svg?react';

import Container from '@/components/container';

import ModalFeedback from './modalFeedback';

import s from './footer.module.css';

const ICON = {
  VK: <VkIcon />,
  'Yandex DZEN': <DzenIcon />,
  YouTube: <YoutubeIcon />,
  Telegram: <TgIcon />,
};

const MP_URL = import.meta.env.VITE_MP_URL;

function Footer() {
  const dispatch = useDispatch();

  const i18n = useSelector(appSelectors.translation);
  const lang = useSelector(appSelectors.language);
  const emails = useSelector(contactsSelectors.emails);
  const socials = useSelector(contactsSelectors.socials);

  const [displayFeedback, setDisplayFeedback] = useState(false);
  const toggleFeedback = () => setDisplayFeedback(!displayFeedback);

  const { isMobile } = useMatchMedia();

  useEffect(() => {
    dispatch(contactsOperations.getContacts());
  }, [dispatch]);

  return (
    <>
      <footer>
        <Container>
          <div className={s.footer}>
            <button
              type="button"
              onClick={toggleFeedback}
              className={s.btn_title}
            >
              {i18n.написать_нам}
            </button>

            <ul className={s.contacts_list}>
              {emails &&
                emails.map(({ id, description, title_en, title_ru }) => (
                  <li key={id}>
                    <p>{lang === 'en' ? title_en : title_ru}</p>
                    <a href={`mailto:${description}`}>{description}</a>
                  </li>
                ))}
            </ul>

            <div className={s.horizontal_line} />

            <ul className={s.nav_list}>
              <li>
                <p>{i18n.VPS_серверы}</p>
                <ul>
                  <li>
                    <Link
                      to={RouteNames.VPS_PAID}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {i18n.Наши_тарифы}
                    </Link>
                  </li>
                  <li>
                    <Link
                      to={RouteNames.VPS_MANUAL}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {i18n.Руководство_пользователя}
                    </Link>
                  </li>
                </ul>
              </li>
              <li>
                <p>{i18n.Онлайн_мониторинг}</p>
                <ul>
                  <li>
                    <Link
                      to={RouteNames.MONITORING}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {i18n.Наши_тарифы}
                    </Link>
                  </li>
                  <li>
                    <Link
                      to={RouteNames.MONITORING_MANUAL}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {i18n.Руководство_пользователя}
                    </Link>
                  </li>
                </ul>
              </li>
              {!isMobile && (
                <li>
                  <p>{i18n.Рибейт_сервис}</p>
                  <ul>
                    <li>
                      <Link
                        to={RouteNames.REBATE}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {i18n.Наши_тарифы}
                      </Link>
                    </li>
                    <li>
                      <Link
                        to={RouteNames.REBATE_BROKERS}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {i18n.Список_брокеров}
                      </Link>
                    </li>
                  </ul>
                </li>
              )}
              <li>
                <p>{i18n.Партнерам}</p>
                <ul>
                  <li>
                    <Link
                      to={RouteNames.PARTNER_CLASSIC}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {i18n.с_каждого_платежа}
                    </Link>
                  </li>
                  <li>
                    <Link
                      to={RouteNames.PARTNER_MULTILEVEL}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {i18n.Многоуровневая_программа}
                    </Link>
                  </li>
                  <li>
                    <Link
                      to={RouteNames.WHITE_LABEL}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {i18n.Программа} White Label
                    </Link>
                  </li>
                  <li>
                    <Link
                      to={RouteNames.RESALE}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {i18n.Программа} {i18n.реселлинга}
                    </Link>
                  </li>
                </ul>
              </li>
              <li>
                <p>{i18n.Помощь}</p>
                <ul>
                  <li>
                    <Link to={RouteNames.ABOUT_US}>{i18n.О_нас}</Link>
                  </li>
                  <li>
                    <Link
                      to={RouteNames.RATING}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {i18n.Рейтинг_форекс_брокеров}
                    </Link>
                  </li>
                  <li>
                    <Link
                      to={RouteNames.COURSES}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {i18n.Курсы_для_новичков}
                    </Link>
                  </li>
                  <li>
                    <Link
                      to={RouteNames.ROBOT}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {i18n.Разработка_на_заказ}
                    </Link>
                  </li>
                  <li>
                    <Link
                      to={RouteNames.GLOSSARY}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {i18n.Глоссарий_терминов}
                    </Link>
                  </li>
                </ul>
              </li>
              {isMobile && (
                <li>
                  <p>{i18n.Рибейт_сервис}</p>
                  <ul>
                    <li>
                      <Link
                        to={RouteNames.REBATE}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {i18n.Наши_тарифы}
                      </Link>
                    </li>
                    <li>
                      <Link
                        to={RouteNames.REBATE_BROKERS}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {i18n.Список_брокеров}
                      </Link>
                    </li>
                  </ul>
                </li>
              )}
              <li>
                <a
                  href={`${MP_URL}?lang=${lang}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Trade Challenge
                </a>
              </li>
            </ul>

            <div className={s.horizontal_line} />

            <div className={s.flex_wrapper}>
              <ul className={s.socials_list}>
                {socials &&
                  socials.map(({ id, description, title_en }) => (
                    <li key={id}>
                      <a
                        href={description}
                        target="_blank"
                        rel="noopener noreferrer"
                        className={s.social_link}
                      >
                        {ICON[title_en]}
                      </a>
                    </li>
                  ))}
              </ul>

              <ul className={s.links_list}>
                <li>
                  <Link
                    to={`/${RouteNames.PUBLIC_OFFER}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {i18n.Публичная_оферта}
                  </Link>
                </li>
                <li>
                  <Link
                    to={`/${RouteNames.PRIVACY_POLICY}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {i18n.Политика_конфиденциальности}
                  </Link>
                </li>
                <li>
                  <Link
                    to={`/${RouteNames.TERMS_OF_SERVICE}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {i18n.Правила_сервиса}
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </Container>
      </footer>
      {displayFeedback && <ModalFeedback close={toggleFeedback} />}
    </>
  );
}

export default Footer;
